import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";
import { PillTheme } from "../pill-theme";

const TagGroupSchema_ = z.object({
  _id: zExt.objectId(),
  team: zExt.objectId(),
  name: z.string(),
  description: z.string().optional(),
  pillTheme: createEnum(PillTheme).default(PillTheme.PRIMARY_LIGHT),
  allowMultipleTags: z.boolean().default(false),
  requireTagBeforeClose: z.boolean().default(false),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export const TagGroupSchema: z.ZodType<TagGroup> = TagGroupSchema_;
export interface TagGroup extends z.infer<typeof TagGroupSchema_> {}

export const CreateTagGroupInputSchema_ = TagGroupSchema_.omit({
  _id: true,
  createdAt: true,
  updatedAt: true,
});

export const CreateTagGroupInputSchema: z.ZodType<CreateTagGroupInput> =
  CreateTagGroupInputSchema_;
export interface CreateTagGroupInput
  extends z.infer<typeof CreateTagGroupInputSchema_> {}

export const UpdateTagGroupInputSchema_ = TagGroupSchema_.omit({
  team: true,
  createdAt: true,
  updatedAt: true,
}).partial();

export const UpdateTagGroupInputSchema: z.ZodType<UpdateTagGroupInput> =
  UpdateTagGroupInputSchema_;
export interface UpdateTagGroupInput
  extends z.infer<typeof UpdateTagGroupInputSchema_> {}
